import React from 'react'
import FeatureMarquee from './FeatureMarquee';
const Feature = () => {
  return (
   <>
   <FeatureMarquee direction="right"/>
      <FeatureMarquee style={{backgroundColor: "white"}} direction="left"/>

   <section className="feature pt-50">
            <div className="container">
                <div className="xb-feature__inner ul_li_center">
                    <div className="xb-feature__item ul_li">
                        <span>
                           <img src="assets/img/icon/f_02.svg" alt=""/>
                        </span>
                        <h5>Result-Oriented Strategies</h5>
                     </div>
                    <div className="xb-feature__item ul_li">
                        <span>
                           <img src="assets/img/icon/f_01.svg" alt=""/>
                        </span>
                        <h5>Creative Designs</h5>
                     </div>
                    <div className="xb-feature__item ul_li">
                        <span>
                           <img src="assets/img/icon/f_03.svg" alt=""/>
                        </span>
                        <h5>SEO Optimization</h5>
                     </div>
                    <div className="xb-feature__item ul_li">
                        <span>
                           <img src="assets/img/icon/f_04.svg" alt=""/>
                        </span>
                        <h5>Improved ROAS</h5>
                     </div>
                    <div className="xb-feature__item ul_li">
                        <span>
                           <img src="assets/img/icon/f_05.svg" alt=""/>
                        </span>
                        <h5>Custom Campaigns</h5>
                     </div>
                    <div className="xb-feature__item ul_li">
                        <span>
                           <img src="assets/img/icon/f_06.svg" alt=""/>
                        </span>
                        <h5>Brand Identity</h5>
                     </div>
                    <div className="xb-feature__item ul_li">
                        <span>
                           <img src="assets/img/icon/f_07.svg" alt=""/>
                        </span>
                        <h5>24/7 Assistance</h5>
                     </div>
                </div>
            </div>

        </section>
        
   </>
  )
}

export default Feature
